import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { NavLinkCompat } from '../Common/NavLinkCompat';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {
  BASE_URL,
  URL_NewUser,
  IsInRole,
  ROLE_OfficeUser,
  ROLE_NewUser,
  ROLE_ClientUser,
  ROLE_LocationUser,
  ROLE_SuperUser,
  ROLE_Driver,
  allowUserWithRoles,
  ROLE_SalesManager
} from '../../constants';
import { userSignedOut } from 'redux-oidc';
import userManager from '../../utils/userManager';

class Sidebar extends Component {

  constructor(props, context) {
    super(props, context);

    this.endSession = this.endSession.bind(this);
    this.reloadApp = this.reloadApp.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    e.target.parentElement.classList.toggle('open');
  }

  toggleSidebar(){
    document.body.classList.remove('sidebar-mobile-show');
  } 

  endSession(e){
    e.preventDefault();
    userManager.signoutRedirect({state: window.location.pathname});
    this.props.dispatch(userSignedOut());
  }

  reloadApp(e) {
    window.location.reload(true);
    e.preventDefault();
  }

  /**
   * 
   * @param {string[]} roles 
   */
  allowRoles(roles = []){
    const {account} = this.props;
    return allowUserWithRoles(account, roles);
  }

  render() {    
    let { users, pendingRequestsTotal, siteConfig, clientLocationsDelivery = []} = this.props;
    let userId = () => {
      return (this.props.account && this.props.account.user) ? this.props.account.user.id : null;
    };

    let usersAuthorisationRequest = users.items.filter(x => x.hasAuthorisationRequest);
    const aboutUsUrl = `http://${siteConfig && siteConfig.siteUrl}/about-us`;
    
    return (
      <div className="sidebar">
        <nav className="sidebar-nav">
          <ul className="nav">  
            {!this.allowRoles([ROLE_NewUser]) && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/`} className="nav-link" activeClassName="active"><i className="icon-home" /> Home </NavLinkCompat>
            </li> }
            { this.allowRoles([ROLE_SuperUser, ROLE_OfficeUser, ROLE_SalesManager]) && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/client-requests`} className="nav-link" activeClassName="active">
                <i className="fa fa-calendar-check-o"/> 
                <span style={{marginLeft: "3px"}}>Client Requests</span> <span className="badge badge-warning">{pendingRequestsTotal}</span>
              </NavLinkCompat>
            </li> }
            { this.allowRoles([ROLE_ClientUser, ROLE_LocationUser]) && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/client-requests`} className="nav-link" activeClassName="active"><i className="fa fa-calendar-check-o" /> 
              <span style={{marginLeft: "3px"}}>Open Requests</span> <span className="badge badge-warning" >{pendingRequestsTotal}</span>
              </NavLinkCompat>
            </li> } 
            { this.allowRoles([ROLE_Driver, ROLE_SuperUser, ROLE_OfficeUser]) && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/runs/driver/`} className="nav-link" activeClassName="active">
                <i className="icon-speedometer" /> My Runs <span className="badge badge-warning">{this.props.driverRuns && this.props.driverRuns.loaded ? this.props.driverRuns.items.filter(x => x.isCurrentUserDriver).length : 0} run(s)</span></NavLinkCompat>
            </li> }
            { this.allowRoles([ROLE_SuperUser, ROLE_OfficeUser]) && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/runs/search/`} className="nav-link" activeClassName="active"><i className="fa fa-search" /> Run Search</NavLinkCompat>
            </li> }
            { this.allowRoles([ROLE_SuperUser, ROLE_Driver]) && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/qr/lookuprun/`} className="nav-link" activeClassName="active"><i className="fa fa-qrcode" /> Run from QR</NavLinkCompat>
            </li> }
            { this.allowRoles([ROLE_SuperUser]) && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/qr/tankassignment/`} className="nav-link" activeClassName="active"><i className="fa fa-random" /> Tank Assignment</NavLinkCompat>
            </li> }
            { this.allowRoles([ROLE_SuperUser]) && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/manage/tanks/`} className="nav-link" activeClassName="active"><i className="fa fa-flask" /> Manage Tanks</NavLinkCompat>
            </li> }
            { /*IsInRole(account, "SuperUser") && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/driver/locations/`} className="nav-link" activeClassName="active"><i className="fa fa-history" /> Driver Locations</NavLinkCompat>
            </li>*/ }
            { this.allowRoles([ROLE_SuperUser]) && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/locations/search/`} className="nav-link" activeClassName="active"><i className="fa fa-institution" /> Location Search</NavLinkCompat>
            </li> }
            { this.allowRoles([ROLE_SuperUser]) && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/manage/regions/`} className="nav-link" activeClassName="active"><i className="fa fa-globe" /> Manage Regions</NavLinkCompat>
            </li> }
            { this.allowRoles([ROLE_SuperUser]) && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/manage/trucks/`} className="nav-link" activeClassName="active"><i className="fa fa-truck" /> Manage Trucks</NavLinkCompat>
            </li> }
            { this.allowRoles([ROLE_SuperUser, ROLE_OfficeUser]) && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/manage/users/`} className="nav-link" activeClassName="active"><i className="fa fa-users" /> Manage Users
                { usersAuthorisationRequest.length > 0 ?
                    <span className="badge badge-warning">{usersAuthorisationRequest.length}</span>
                  : <span className="badge badge-success">{users.items.filter(x => x.isActive).length}</span> }
              </NavLinkCompat>
            </li> }

            { this.allowRoles([ROLE_SuperUser]) && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/manage/bdms/`} className="nav-link" activeClassName="active"><i className="fa fa-suitcase" /> Manage BDMs</NavLinkCompat>
            </li> }
            { this.allowRoles([ROLE_SuperUser, ROLE_OfficeUser])&& <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/manage/locations/`} className="nav-link" activeClassName="active"><i className="fa fa-trash" /> Client Locations</NavLinkCompat>
            </li> }
            { this.allowRoles([ROLE_SuperUser]) && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/rebatesRCTI`} className="nav-link" activeClassName="active"><i className="fa fa-sticky-note" /> Rebates RCTI</NavLinkCompat>
            </li> }
            { this.allowRoles([ROLE_SuperUser]) && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/invoice`} className="nav-link" activeClassName="active"><i className="fa fa-sticky-note" /> Invoice</NavLinkCompat>
            </li> }
            { this.allowRoles([ROLE_SuperUser]) && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/myob-configuration`} className="nav-link" activeClassName="active"><i className="fa fa-gear" /> Integrations</NavLinkCompat>
            </li> }

            { this.allowRoles([ROLE_NewUser]) && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={URL_NewUser} className="nav-link" activeClassName="active"><i className="fa fa-home" /> Home</NavLinkCompat>
            </li> }

            

            {/* Urgent Request Collection */}
            { this.allowRoles([ROLE_ClientUser, ROLE_LocationUser]) && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/request-urgent-collection`} className="nav-link flex" activeClassName="active">
                <i className="fa fa-truck" />
                <span style={{marginLeft: "2px"}}>Request Urgent </span>
                <span style={{marginLeft: "30px"}}>Collection</span>
              </NavLinkCompat>
            </li> }

            { this.allowRoles([ROLE_ClientUser, ROLE_LocationUser]) && clientLocationsDelivery && clientLocationsDelivery.length > 0 && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/request-oil-delivery`} className="nav-link flex" activeClassName="active">
                <i className="fa fa-truck" />
                <span style={{marginLeft: "2px"}}>Request Delivery</span>
              </NavLinkCompat>
            </li> }

            {/* New Oil - old route `${BASE_URL}/request-new-oil` */}
            { this.allowRoles([ROLE_ClientUser, ROLE_LocationUser]) && clientLocationsDelivery && clientLocationsDelivery.length === 0 && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/request-new-oil`} className="nav-link flex" activeClassName="active">
                <i className="fa fa-truck" />
                <span style={{marginLeft: "2px"}}>New Oil</span>
              </NavLinkCompat>
            </li> }

            {/* Tank Repair */}
            { this.allowRoles([ROLE_ClientUser, ROLE_LocationUser]) && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/request-tank-swap`} className="nav-link" activeClassName="active"><i className="fa fa-wrench" />
                <span style={{marginLeft: "2px"}}>Tank Repair</span>
              </NavLinkCompat>
            </li> }


            {/* Update Details */}
            { userId() && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/manage/users/${userId()}`} className="nav-link" activeClassName="active"><i className="icon-user" /> Update Details</NavLinkCompat>
            </li> }

            {/* Global Settings */}
            { this.allowRoles([ROLE_SuperUser]) && <li className="nav-item" onClick={this.toggleSidebar}>
              <NavLinkCompat to={`${BASE_URL}/global-settings`} className="nav-link" activeClassName="active"><i className="fa fa-cogs" /> Global Settings</NavLinkCompat>
            </li> }

            <li className="nav-item">
              <a href="#" onClick={this.endSession} className="nav-link"><i className="fa fa-arrow-right" /> Logout</a>
            </li>
            <li className="nav-item">
              <a href="#" onClick={this.reloadApp} className="nav-link"><i className="fa fa-recycle" /> Reload App</a>
            </li>

            {/* About Us */}
            { this.allowRoles([ROLE_ClientUser, ROLE_LocationUser]) && <li className="nav-item" onClick={this.toggleSidebar}>
              <a href={aboutUsUrl} target="_blank" className="nav-link"><i className="fa fa-info" />  About Us</a>  
            </li> }
 
            <li className="divider" /> 
          </ul>
        </nav>
      </div>
    );
  }
}

Sidebar.propTypes = {
  driverRuns: PropTypes.object,
  account: PropTypes.object,
};

function mapStateToProps(state){
  return {
    account: state.account,
    users: state.users,
    pendingRequestsTotal: (state.clientRequests && state.clientRequests.total),
    siteConfig: state.apiConfig,
    clientLocationsDelivery: state.home.clientLocationsDelivery
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);

